<template>
  <div>
    <div class="modal-card" style="width: 800px">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ title }}
        </p>
      </header>
      <section class="modal-card-body">
        <b-field label="Désignation de la campagne" required>
          <b-input
            type="text"
            v-model="campaign.name"
            ref="campaign.name"
            refInFor="true"
            required
          />
        </b-field>
        <b-field label="Client commanditaire" required>
          <b-input
            v-model="campaign.client"
            ref="campaign.client"
            required
          ></b-input>
        </b-field>
        <b-field label="Emails des répondants - séparés par ';'" required>
          <b-input
            type="textarea"
            v-model="campaign.answerings"
            ref="campaign.answerings"
            required
          ></b-input>
        </b-field>
        <b-field
          class="block"
          label="Type de questionnaire"
          required
          :type="{ 'is-danger': !hasSelectedSurvey }"
          :message="[
            {
              'Veuillez choisir un type de questionnaire': !hasSelectedSurvey,
            },
          ]"
        >
          <b-checkbox v-model="campaign.surveys" native-value="itp" selected>
            ITP
          </b-checkbox>
        </b-field>
        <b-field class="block" label="Droit du répondant" required>
          <b-checkbox v-model="campaign.userShouldHaveResult">
            Les répondants pourront consulter les résultats sur le site et par
            email.
          </b-checkbox>
        </b-field>

        <div class="notification is-info is-light">
          A l'enregistrement de la campagne le répondant recevra un email
          contenant les instructions de connexion et d'utilisation du site.
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          Fermer
        </button>
        <button class="button is-primary" @click="editCampaign">
          Enregistrer
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { validateEmail } from "@/services/mailServices.js";
export default {
  props: {
    campaign: {
      default: () => ({
        name: "",
        client: "",
        answerings: "",
        surveys: ["itp"],
        userShouldHaveResult: false,
        id: undefined,
      }),
    },

    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      hasSelectedSurvey: true,
    };
  },
  methods: {
    editCampaign() {
      var isValid = true;
      Object.values(this.$refs).forEach((input) => {
        input.checkHtml5Validity();

        isValid = isValid && input.isValid;
      });

      // check portfolio specificity
      this.hasSelectedSurvey =
        this.campaign.surveys != undefined && this.campaign.surveys.length > 0;
      isValid = isValid && this.hasSelectedSurvey;

      // remove space
      this.campaign.answerings = this.campaign.answerings.replaceAll(" ", "");
      // check email validity
      this.campaign.answerings.split(";").forEach((answering) => {
        console.log(answering);
        if (answering != undefined) {
          if (validateEmail(answering) == null) {
            isValid = false;
            this.$buefy.snackbar.open({
              message: "L'email " + answering + " est incorrect.",
              type: "is-danger",
              queue: false,
              indefinite: true,
            });
          }
        }
      });

      if (isValid) {
        this.$emit("edit-campaign", this.campaign);
      } else {
        this.$buefy.snackbar.open({
          message:
            "Une erreur a été détectée, merci de corriger le formulaire.",
          type: "is-danger",
          queue: false,
        });
      }
    },
  },
};
</script>
<style lang="css">
.is-danger {
  border-color: #f04124 !important;
}
</style>
